var map = {
	"./images/wings.png": 1832
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1831;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners ^.*\/wings\.png$
// module id = 1831
// module chunks = 147